export const TYPE = {
  DISPLAY: "DISPLAY",
  MOBILE: "MOBILE",
  VIDEO: "VIDEO",
};

export const MODAL_TYPE = {
  ADD: "add",
  EDIT: "edit",
  COPY: "copy",
  JSON: "json",
};

export const BRANDED = {
  BLOCKED: "BLOCKED",
  ALLOWED: "ALLOWED",
};
